import StocklistComponent from './components/StocklistComponent';

window.addEventListener('vue-init', () => {
    mountVueComponent('stocklist', StocklistComponent);
})

if (typeof(mountVueComponent) == 'function') {
    mountVueComponent('stocklist', StocklistComponent);
}
